module.exports = __webpack_public_path__ + "img/FlatFare.ebcf4934.png";